import React, { useState } from "react";
import LoginLayout from "../../components/Login";

export default function PartnerLogin() {

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
     <LoginLayout role={"Partner"} />
    </div>
  );
}
